(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inara-header"]) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      const bars = scope.matches?.('[data-inara-announcement]')
        ? [scope]
        : Array.from(scope.querySelectorAll('[data-inara-announcement]'));

      bars.forEach((bar) => {
        if (bar.dataset.announcementInitialized) return;
        const messages = Array.from(bar.querySelectorAll('[data-announcement-message]'));
        if (messages.length < 2) return;
        bar.dataset.announcementInitialized = 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const autoRotate = bar.dataset.autoplay === 'true';
        const interval = Math.max(5000, Number(bar.dataset.interval) || 6000);
        let index = 0;
        let timer;
        let animating = false;
        let animations = [];
        let hovered = false;
        let focused = false;

        const showMessage = (nextIndex) => {
          if (animating) return;
          const targetIndex = (nextIndex + messages.length) % messages.length;
          if (targetIndex === index) return;
          const previous = messages[index];
          const next = messages[targetIndex];
          index = targetIndex;
          next.hidden = false;
          previous.setAttribute('aria-hidden', 'true');
          next.setAttribute('aria-hidden', 'false');
          if (reducedMotion.matches || typeof next.animate !== 'function') {
            previous.hidden = true;
            return;
          }
          animating = true;
          const options = { duration: 500, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
          animations = [
            previous.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }], options),
            next.animate([{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }], options)
          ];
          Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
            previous.hidden = true;
            animations.forEach((animation) => animation.cancel());
            animations = [];
            animating = false;
          });
        };

        const schedule = () => {
          clearTimeout(timer);
          if (!bar.isConnected || !autoRotate || reducedMotion.matches || hovered || focused || document.hidden) return;
          timer = setTimeout(() => {
            showMessage(index + 1);
            schedule();
          }, interval);
        };

        bar.querySelector('[data-announcement-next]').addEventListener('click', () => {
          showMessage(index + 1);
          schedule();
        });
        bar.addEventListener('pointerenter', () => { hovered = true; schedule(); });
        bar.addEventListener('pointerleave', () => { hovered = false; schedule(); });
        bar.addEventListener('focusin', () => { focused = true; schedule(); });
        bar.addEventListener('focusout', (event) => {
          focused = Boolean(event.relatedTarget && bar.contains(event.relatedTarget));
          schedule();
        });
        document.addEventListener('visibilitychange', schedule);
        const unload = (event) => {
          if (!event.target.contains(bar)) return;
          clearTimeout(timer);
          animations.forEach((animation) => animation.cancel());
          document.removeEventListener('visibilitychange', schedule);
          document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
        schedule();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inara-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inara-product-recommendations')) {
    customElements.define('inara-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.performed === 'true' || this.dataset.loaded === 'true' || this.observer) return;
        this.controller = new AbortController();
        if (!('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadRecommendations();
        }, { rootMargin: '300px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.controller?.abort();
        this.loading = false;
      }

      async loadRecommendations() {
        if (this.loading || this.dataset.loaded === 'true') return;
        this.loading = true;
        this.observer?.disconnect();
        this.observer = null;
        try {
          const response = await fetch(this.dataset.url, {
            signal: this.controller.signal,
            credentials: 'same-origin',
            headers: { Accept: 'text/html' }
          });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = html.querySelector('inara-product-recommendations');
          const content = root?.querySelector('[data-recommendations-content]');
          if (Number(root?.dataset.relatedCount) > 0 && content && this.isConnected) {
            this.replaceChildren(content);
          }
          this.dataset.loaded = 'true';
        } catch {
        } finally {
          this.loading = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
